import $ from 'jquery';
const aosAnim = (() => {

  const socialAnim = () => {
    var elems = [$('.circle-bg-fb'), $('.circle-bg-tw'), $('.circle-bg-p')];
    var cls = ["circle-bg-fb-end", "circle-bg-tw-end", "circle-bg-p-end"];

      $('div#social-holder').on("click", function(){
        for(var i=0; i<elems.length; i++) {
            elems[i].toggleClass(cls[i]);
        };
      });
      $("#social-holder a").on("click", function(){
        var iMyWidth;
        var iMyHeight;
        var thLnk = $(this).attr("href");
        //half the screen width minus half the new window width (plus 5 pixel borders).
        iMyWidth = (window.screen.width/2) - (75 + 10);
        //half the screen height minus half the new window height (plus title and status bars).
        iMyHeight = (window.screen.height/2) - (100 + 50);
        //Open the window.
        var win2 = window.open(thLnk,"Window2","status=no,height=500,width=700,resizable=yes,left=" + iMyWidth + ",top=" + iMyHeight + ",screenX=" + iMyWidth + ",screenY=" + iMyHeight + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no");
        win2.focus();
      });
  };


  const init = () => {
    socialAnim();
  };

  return {
    init,
  };
})();

export default aosAnim;
